import { css } from 'styled-components';
import { marginStyles } from '../../styles/components.js';
import { addContentMask } from '../../utils/color-manipulation.js';
import 'react';
import { LinkIcon } from './shared.style.js';

const shiftIcon = () => css `
  ${LinkIcon} {
    transform: translateX(4px);
  }
`;
const focus = (props) => css `
  box-shadow: 0 0 0 2px
    ${addContentMask({
    color: props.color || 'blue',
    lighten: true,
    props,
})};
  padding: 5px 2px;
  margin: -5px -2px;
  border-radius: 6px;
  outline: transparent solid 2px;

  ${shiftIcon}
`;
const hover = (props) => css `
  ${shiftIcon}
  color: ${addContentMask({ color: props.color || 'primary', props })};

  svg {
    path {
      fill: ${addContentMask({ color: props.color || 'primary', props })};
    }
  }
`;
const StandaloneStyles = (props) => css `
  align-items: center;
  color: ${props.theme.colors.content[props.color || 'primary']};
  cursor: pointer;
  display: inline-flex;
  font-family: ${props.theme.fontFamilies.main.medium};
  font-size: ${props.theme.fontSizes[props.fontSize || 500]};
  text-align: ${props.textAlign ? props.textAlign : 'center'};
  -webkit-font-smoothing: antialiased;
  text-decoration: underline;
  white-space: ${props.whiteSpace ? props.whiteSpace : 'normal'};
  ${marginStyles(props.margin)};

  &:focus {
    ${focus}
  }

  &:hover {
    ${hover}
  }
`;

export { StandaloneStyles };
